import * as React from 'react';
import { FetchBordereauOptions, fetchMonthlyBRBordereau } from 'services/reporting';
import { useSelector } from 'react-redux';
import { getUserGroups } from 'application/redux/selectors';
import { ReportingTabProps } from 'types/reporting.type';
import { AUTH_GROUPS } from '../../../../../constants';
import { getRolesContain } from 'helpers/roles';
import ReportDownloadsPanel from '../../../../../components/Reporting/components/ReportDownloadsPanel';

const DownloadReports: React.FunctionComponent<ReportingTabProps> = (props) => {
    const userGroups = useSelector(getUserGroups);

    const options = [
        {
            label: 'Ally',
            entity: 'ALLY_BR',
            contentType: 'text/csv',
            filename: 'Ally_BR_Bordereaux',
            permissions: [AUTH_GROUPS.ADMIN, AUTH_GROUPS.UNDERWRITER, AUTH_GROUPS.ACCOUNT_MANAGER],
        },
        {
            label: 'Accelerant',
            entity: 'ACCELERANT_BR',
            contentType: 'text/csv',
            filename: 'Accelerant_BR_Bordereaux',
            permissions: [AUTH_GROUPS.ADMIN, AUTH_GROUPS.UNDERWRITER, AUTH_GROUPS.ACCOUNT_MANAGER],
        },
    ];

    return (
        <ReportDownloadsPanel
            title="Download Reports"
            options={options.filter((option) => getRolesContain(userGroups, option.permissions))}
            fetchDownloadFile={(fetchOptions: FetchBordereauOptions) => fetchMonthlyBRBordereau(fetchOptions)}
        />
    );
};

export default DownloadReports;
